import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaFilePdf } from "react-icons/fa";

import "./Admision.css";

const Becas = () => {
  

  return (
    <section className="becas-page">
      {/*  Banner superior */}
      <div className="info-hero" data-aos="fade-down">
        <div className="overlay"></div>
        <div className="container text-center text-white">
          <h1 className="fw-bold">Becas y Créditos Educativos</h1>
          <p className="lead">
            Oportunidades de apoyo económico para nuestros estudiantes destacados.
          </p>
        </div>
      </div>

      {/*  Contenido principal */}
      <div className="container py-5">
    
        <div
          className="becas-info bg-white rounded-4 shadow-sm p-4 mb-4"
          data-aos="fade-up"
        >
          <h3 className="section-subtitle mb-3">Tipos de Becas</h3>
          <ul className="styled-list">
            <li>
              Descuento del <strong>100%</strong> en la matrícula a los{" "}
              <strong>primeros puestos</strong> de cada ciclo de los 5 programas
              de estudios.
            </li>
            <li>
              Descuento del <strong>50%</strong> en la matrícula a los{" "}
              <strong>estudiantes que realizan servicio militar acuartelado</strong>.
            </li>
            <li>
              Otras becas otorgadas por el{" "}
              <strong>IESTP “Gilda Liliana Ballivián Rosado”</strong>, la{" "}
              <strong>DRELM</strong> o el <strong>MINEDU</strong>.
            </li>
          </ul>
        </div>

      </div>

    </section>
  );
};

export default Becas;
